import { render, staticRenderFns } from "./PasswordExpiration.vue?vue&type=template&id=577bb5b7&scoped=true&"
import script from "./PasswordExpiration.vue?vue&type=script&lang=js&"
export * from "./PasswordExpiration.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpiration.vue?vue&type=style&index=0&id=577bb5b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577bb5b7",
  null
  
)

export default component.exports